import { ApiResponse } from '@nf/types/api';
import { GroupDate, MatchGroup, Group, MatchGroupDetail, MatchGroupNextGame, GoldenDuelSetting, TicketGroup, GroupStatus, GroupByMatchIdData, GroupByMatchIdsData } from './types';
import { goldenDuelTimezoneService } from '@/services/golden-duel/timezone-service';

const MOCK_DELAY = 1000;

const createAsyncMock = <T>(mockData: T): Promise<T> => {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve(mockData);
		}, MOCK_DELAY);
	});
};

const goldenDuelSettingData: ApiResponse<GoldenDuelSetting> = {
	Data: {
		SportId: 2,
		LeagueIds: [53, 56],
		CurrencySettings: [
			{
				CurrencyId: 2, // MYR
				TargetAmount: 15.00,
				ActualRate: 1.00
			},
			{
				CurrencyId: 3, // USD
				TargetAmount: 5.00,
				ActualRate: 4.01
			},
			{
				CurrencyId: 7, // DON
				TargetAmount: 75000.00,
				ActualRate: 0.0002
			},
			{
				CurrencyId: 20, // UUS
				TargetAmount: 30.00,
				ActualRate: 0
			}
		]
	},
	ErrorCode: 0,
	ErrorMsg: ''
};

const groupByMatchIdData: ApiResponse<GroupByMatchIdData> = {
	Data: { DrawTime: '2025-04-30T00:00:00' },
	ErrorCode: 0,
	ErrorMsg: ''
};

const groupByMatchIdsData: ApiResponse<GroupByMatchIdsData[]> = {
	Data: [{ DrawTime: '2025-04-30T00:00:00', MatchId: 2001 }],
	ErrorCode: 0,
	ErrorMsg: ''
};

const groupDatesData: ApiResponse<GroupDate[]> = {
	Data: [
		{
			GroupId: '1001',
			DrawTime: '2025-03-21T15:30:00Z',
			Status: true
		},
		{
			GroupId: '1002',
			DrawTime: '2025-03-22T15:30:00Z',
			Status: false
		}
	],
	ErrorCode: 0,
	ErrorMsg: ''
};

const matchGroupsData: ApiResponse<MatchGroup[]> = {
	Data: [
		{
			GroupId: '1001',
			Status: GroupStatus.Pending,
			PoolAmount: 10000,
			DrawTime: '2025-03-21T15:30:00Z',
			Matches: [
				{
					MatchId: 2001,
					GameNo: 1,
					SeriesRecord: '0-0',
					HomeId: 1,
					AwayId: 2,
					HomeName: 'PHX',
					AwayName: 'MIA',
					HomeFtScore: 100,
					AwayFtScore: 90,
					Event: 'A'
				},
				{
					MatchId: 2002,
					GameNo: 2,
					SeriesRecord: '1-1',
					HomeId: 3,
					AwayId: 4,
					HomeName: 'LAL',
					AwayName: 'GSW',
					HomeFtScore: undefined,
					AwayFtScore: undefined,
					Event: 'B'
				}
			]
		}
	],
	ErrorCode: 0,
	ErrorMsg: ''
};

const groupsData: ApiResponse<Group[]> = {
	Data: [
		{
			GroupId: '1001',
			Status: 0,
			PoolAmount: 10000,
			DrawTime: '2025-03-21T15:30:00Z'
		},
		{
			GroupId: '1002',
			Status: 1,
			PoolAmount: 15000,
			DrawTime: '2025-03-22T15:30:00Z'
		}
	],
	ErrorCode: 0,
	ErrorMsg: ''
};

const matchGroupDetailData: ApiResponse<MatchGroupDetail> = {
	Data: {
		PrizeTotalAmount: 10000,
		PrizeLevel: 1,
		DrawTime: '2025-03-21T15:30:00Z',
		WinNumber: '?,?,?,4,6',
		Status: GroupStatus.Drawn,
		WinNumberSource: [
			{
				Event: 'A',
				TeamName: 'PHX',
				Stats: 1,
				Statistic: 121,
				Picked: 1,
				MatchId: 2001
			}
		],
		Matches: [
			{
				MatchId: 2001,
				GameNo: 1,
				SeriesRecord: '0-0',
				HomeId: 1,
				AwayId: 2,
				HomeName: 'PHX',
				AwayName: 'MIA',
				HomeFtScore: 110,
				AwayFtScore: 105,
				HomeHtScore: 55,
				AwayHtScore: 52,
				Event: 'NBA Regular Season'
			}
		],
		PrizeDetail: {
			LastRemainAmount: 0,
			PoolAmount: 10000
		},
		PrizeDrawDetail: [
			{
				PrizeLevel: 1,
				Prize: 5000,
				TicketCount: 10,
				PrizeFund: 50000
			}
		],
		NextGameDetail: {
			MatchId: 2002,
			GameNo: 2,
			JoinType: 1,
			HomeName: 'LAL',
			AwayName: 'GSW'
		}
	},
	ErrorCode: 0,
	ErrorMsg: ''
};

const matchGroupNextGameData: ApiResponse<MatchGroupNextGame> = {
	Data: {
		MatchId: 2002,
		GameNo: 2,
		JoinType: 1,
		HomeName: 'LAL',
		AwayName: 'GSW'
	},
	ErrorCode: 0,
	ErrorMsg: ''
};

const ticketGroupsData: ApiResponse<TicketGroup[]> = {
	Data: [
		{
			GroupId: '1001',
			DrawTime: goldenDuelTimezoneService.clientToGmtMinus4('2025-04-01'),
			Status: 0, // 未派彩
			WinNumber: '',
			Tickets: [
				{
					MatchId: 2002,
					TransId: 2025032100002,
					HomeName: 'LAL',
					AwayName: 'GSW',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-21T11:30:00'),
					Status: 0  // 未中獎
				}
			]
		},
		{
			GroupId: '1002',
			DrawTime: goldenDuelTimezoneService.clientToGmtMinus4('2025-04-02'),
			Status: 0, // 未派彩
			WinNumber: '?,?,?,3,7',
			Tickets: [
				{
					MatchId: 2003,
					TransId: 2025032200001,
					HomeName: 'BOS',
					AwayName: 'BKN',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-22T09:15:00'),
					Status: 0  // 未中獎
				}
			]
		},
		{
			GroupId: '1003',
			DrawTime: goldenDuelTimezoneService.clientToGmtMinus4('2025-04-03'),	
			Status: 1, // 已派彩
			WinNumber: '1,0,0,0,4,6',
			Tickets: [
				{
					MatchId: 2002,
					TransId: 2025032100002,
					HomeName: 'LAL',
					AwayName: 'GSW',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-21T11:30:00'),
					Status: 0  // 未中獎
				},
				{
					MatchId: 2001,
					TransId: 2025032200046,
					HomeName: 'PHX',
					AwayName: 'MIA',
					PrizeAmount: 100.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-21T10:30:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2001,
					TransId: 2025032100046,
					HomeName: 'PHX',
					AwayName: 'MIA',
					PrizeAmount: 100.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-21T10:30:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2004,
					TransId: 2025032300001,
					HomeName: 'DEN',
					AwayName: 'DAL',
					PrizeAmount: 15.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-23T14:20:00'),
					Status: 2  // Canceled
				}
			]
		},
		{
			GroupId: '1004',
			DrawTime: goldenDuelTimezoneService.clientToGmtMinus4('2025-04-04'),
			Status: 1, // 已派彩
			WinNumber: '2,1,1,1,5,7',
			Tickets: [
				{
					MatchId: 2005,
					TransId: 2025032400001,
					HomeName: 'MIL',
					AwayName: 'PHI',
					PrizeAmount: 500.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-24T09:00:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2006,
					TransId: 2025032400002,
					HomeName: 'BOS',
					AwayName: 'TOR',
					PrizeAmount: 200.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-24T10:00:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2007,
					TransId: 2025032400003,
					HomeName: 'LAC',
					AwayName: 'UTA',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-24T11:00:00'),
					Status: 0  // 未中獎
				},
				{
					MatchId: 2008,
					TransId: 2025032400004,
					HomeName: 'DAL',
					AwayName: 'HOU',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-24T12:00:00'),
					Status: 0  // 未中獎
				},
				{
					MatchId: 2009,
					TransId: 2025032400005,
					HomeName: 'POR',
					AwayName: 'SAC',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-24T13:00:00'),
					Status: 2  // Canceled
				}
			]
		},
		{
			GroupId: '1005',
			DrawTime: goldenDuelTimezoneService.clientToGmtMinus4('2025-04-05'),
			Status: 1, // 已派彩
			WinNumber: '3,2,2,2,6,8',
			Tickets: [
				{
					MatchId: 2010,
					TransId: 2025032500001,
					HomeName: 'LAL',
					AwayName: 'MEM',
					PrizeAmount: 1000.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-25T09:00:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2011,
					TransId: 2025032500002,
					HomeName: 'GSW',
					AwayName: 'MIN',
					PrizeAmount: 800.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-25T10:00:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2012,
					TransId: 2025032500003,
					HomeName: 'DEN',
					AwayName: 'OKC',
					PrizeAmount: 600.00,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-25T11:00:00'),
					Status: 1  // 中獎
				},
				{
					MatchId: 2013,
					TransId: 2025032500004,
					HomeName: 'PHX',
					AwayName: 'SAS',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-25T12:00:00'),
					Status: 0  // 未中獎
				},
				{
					MatchId: 2014,
					TransId: 2025032500005,
					HomeName: 'NOP',
					AwayName: 'CHA',
					PrizeAmount: 0,
					TransDate: goldenDuelTimezoneService.clientToGmtMinus4('2025-03-25T13:00:00'),
					Status: 2  // Canceled
				}
			]
		}
	],
	ErrorCode: 0,
	ErrorMsg: ''
};

export const mockGoldenDuelSetting = () => createAsyncMock(goldenDuelSettingData);
export const mockGroupByMatchId = () => createAsyncMock(groupByMatchIdData);
export const mockGroupByMatchIds = () => createAsyncMock(groupByMatchIdsData);
export const mockGroupDates = () => createAsyncMock(groupDatesData);
export const mockMatchGroups = () => createAsyncMock(matchGroupsData);
export const mockGroups = () => createAsyncMock(groupsData);
export const mockMatchGroupDetail = () => createAsyncMock(matchGroupDetailData);
export const mockMatchGroupNextGame = () => createAsyncMock(matchGroupNextGameData);
export const mockTicketGroups = () => createAsyncMock(ticketGroupsData);